import { useState, useCallback } from "react";
import {
  formatPublishDate,
  formatGameTime,
  getTimeDescriptor,
} from "app/util/timeUtils";
import useGameState from "app/game/useGameState";
import useGameData from "app/game-data/useGameData";

const GAMES_HOME_URL = import.meta.env.VITE_GAMES_HOME_URL as string;
const GAME_SHARE_URL = `${GAMES_HOME_URL}/pixellence`;

export default function useShareText() {
  const data = useGameData();
  const { gameTime } = useGameState();
  const [isCopied, setCopied] = useState<boolean>(false);

  const date = data ? `${formatPublishDate(data.publishDate)}` : "";
  const formattedGameTime = formatGameTime(gameTime);

  let shareText = `I solved Pixellence on ${date} in ${formattedGameTime} ${getTimeDescriptor(formattedGameTime)}.`;
  // shareText += `\n🕑 Time: ${gameTime}`;
  shareText += `\n${GAME_SHARE_URL}?utm_campaign=tedspread&utm_medium=referral&utm_source=tedcomshare`;

  const copyToClipboard = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(shareText);
      setCopied(true);
    } catch (clipboardError) {
      console.error("Failed to copy to clipboard: ", clipboardError);
    }
  }, [shareText]);

  const navigatorShareText = useCallback(async () => {
    const shareData: ShareData = {
      title: "Pixellence",
      text: shareText,
      url: "",
    };

    try {
      if (!navigator.canShare(shareData)) {
        throw new Error("Navigator can't share data");
      }

      await navigator.share(shareData);
    } catch (error) {
      copyToClipboard();
      console.error("Failed to share: ", error);
    }
  }, [shareText, copyToClipboard]);

  return {
    text: shareText,
    isCopied,
    setCopied,
    navigatorShareText: navigatorShareText,
    copyToClipboard: copyToClipboard,
  };
}
